module.exports = __webpack_public_path__ + "static/media/19ESCAP37.4baf9e81.jpg";